module.exports = __webpack_public_path__ + "static/products-grid2-9827e8b51453c398abd7cc9d8f12217f.jpg";